//import {  concourseId } from '../constants/activity-constants'

const getUrlIdRegister = concourseId => {
  const pathName = window.location.pathname.slice(1)
  return `/registro/?url=${pathName}&id=${concourseId}`
}

export default getUrlIdRegister
